import { Outlet } from "react-router-dom"
import { NewReportProvider } from "../providers/NewReportProvider"
import PlaygroundBanner from "../components/PlaygroundBanner"

const ReportFormContainer = ({ sandbox = false }: { sandbox?: boolean }) => {
    return (
        <NewReportProvider sandbox={sandbox}>
            {sandbox && <PlaygroundBanner />}
            <Outlet />
        </NewReportProvider>
    )
}

export default ReportFormContainer;
